/*
 * Copyright 2024
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Last modified: 2024.5.6 at 18:42
 */

export default () => {
    const iOS = !window.MSStream && /iPhone|iPod/.test(navigator.userAgent);
    const init = () => {
        if (iOS && window.innerWidth <= 375 && document.body.classList.contains('page-id-12')) {
            const titleEle = document.getElementById('titel');
            const marks = titleEle.getElementsByTagName('mark');

            if (marks && marks.length) {
                const mark = marks.item(0);
                if (mark.innerText.includes('ZIRKULÄRES')) {
                    mark.innerText = mark.innerText.replace('ZIRKULÄRES', 'ZIRKU-LÄRES');
                }
            }
        }
    };
    init();
};
